import { Tab, Tabs, TabPanel } from 'react-tabs'
import { setSelectedToolbarGarageSubTab } from '../../store/ui/uiSlice'
import ItemPanel from '../ItemPanel/ItemPanel'
import * as Styled from '../styles'
import { useAppDispatch, useAppSelector } from '../../hooks'

export default function GaragePanel() {
  const dispatch = useAppDispatch()
  const { content } = useAppSelector((state) => state.init)
  const { selectedToolbarGarageSubTab } = useAppSelector((state) => state.ui)

  return (
    <Tabs
      selectedIndex={selectedToolbarGarageSubTab}
      onSelect={(index) => {
        dispatch(setSelectedToolbarGarageSubTab(index))
      }}
    >
      <Styled.SubTabsList>
        <Tab tabIndex="0">{content?.items?.garageDoors?.title}</Tab>
        <Tab tabIndex="2">{content?.items?.slidingDoors?.title}</Tab>
        <Tab tabIndex="3">{content?.items?.facadeSections?.title}</Tab>
      </Styled.SubTabsList>
      <TabPanel>
        <ItemPanel itemType="garageDoors" />
      </TabPanel>
      <TabPanel>
        <ItemPanel itemType="slidingDoors" />
      </TabPanel>
      <TabPanel>
        <ItemPanel itemType="facadeSections" />
      </TabPanel>
    </Tabs>
  )
}
